<template>
  <div
    v-if="showModal"
    class="fixed inset-0 flex items-center justify-center bg-black/80 z-[999] px-4 backdrop-blur-sm"
  >
    <div
      class="relative w-full max-w-md bg-[#14181F] border border-gray-800 p-8 rounded-[16px] shadow-[0_10px_40px_rgba(0,0,0,0.5)] text-center"
    >
      <!-- Close Button -->
      <button
        @click="closeModal"
        class="absolute top-4 right-5 text-gray-400 text-3xl font-bold hover:text-white transition-colors"
      >
        &times;
      </button>

      <!-- Title -->
      <h2 class="text-2xl sm:text-3xl font-black text-white font-oxanium tracking-wide uppercase mb-4 mt-2">
        <span class="text-[#00F0FF]">{{ $t("Modal.Login_Required.Header_Login") }}</span> {{ $t("Modal.Login_Required.Header_Required") }}
      </h2>

      <!-- Content -->
      <div class="text-[#B9CACB] text-sm sm:text-base space-y-3 mb-8">
        <p>{{ $t("Modal.Login_Required.Content_1") }}</p>
        <p>{{ $t("Modal.Login_Required.Content_2") }}</p>
      </div>

      <!-- Actions -->
      <div class="flex flex-col sm:flex-row gap-3">
        <button
          @click="handleLogin"
          class="flex-1 px-6 py-3 bg-[#00F0FF] text-black font-bold text-sm rounded-[10px] hover:bg-[#00d4e0] transition-colors uppercase tracking-wider"
        >
        {{ $t("Modal.Login_Required.Go_To_Login") }}
        </button>

        <a
          href="https://discord.gg/N764VWuGyn"
          target="_blank"
          class="flex-1 px-6 py-3 flex items-center justify-center bg-[#5865F2] text-white font-bold text-sm rounded-[10px] hover:bg-[#4855c8] transition-colors uppercase tracking-wider"
        >
        {{ $t("Modal.Login_Required.Join_Discord") }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showModal: Boolean,
    isUserLoggedIn: Boolean,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    redirectToProfile() {
      this.closeModal();
      this.$router.push("/profile");
    },
    handleLogin() {
      const loginUrl = `${process.env.VUE_APP_BASE_API}/api/auth/login/kick`;
      window.location.href = loginUrl;
    },
  },
};
</script>
